import { Link } from "react-scroll";

export default function HeroSection()
{
    return (
        <section id="heroSection" className="hero--section">
          <div className="hero--section--content--box">
            <div className="hero--section--content">
              <p className="section--title">Hey, I'm Aparna!</p>
              <h1 className="hero--section--title">
                <span className="hero--section-title--color">Computer Science</span>{" "}
                <br />
                Graduate
              </h1>
              <p className="hero--section-description">
                MSU grad, MCS student at UIUC, and Software Developer.
                <br /> Passionate about technical innovation and building seamless tools.
              </p>
            </div>
            <Link
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Contact"
              className="btn btn-primary"
            >
              Get In Touch
            </Link>
          </div>
          <div className="hero--section--img">
            <img src="./img/aps-hero-img-1.jpg" alt="Hero Section" />
          </div>
        </section>
      );
    
}